export default "__VITE_ASSET__Bu3VTsrk__"